import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Data} from "../../../../types/homeWorkSchema";



const initialState = {
    data: {} as Data,
    isLoading: true,
    error: null,
    status: 200,
};

const homeWorkSlice = createSlice({
    name: "homeWork",
    initialState,
    reducers: {
        setHomeWork: (state, action) => {
            const { data } = action.payload;
            state.data = data;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;

        },

    },
});

export const { setHomeWork, setLoading, setError } = homeWorkSlice.actions;


export const homeWorkReducer = homeWorkSlice.reducer;

